import { useState, useEffect } from "react";
import { useColors } from "../ColorsContext";
import WristbandIcon from "./WristbandIcon";

/**
 * Sticky wristband save footer used at the bottom of all checkpoint screens.
 * Locked state: grey, padlock icon, explains why it's unavailable.
 * Unlocked state: path-coloured, pulsing, prompts scan.
 */
export default function WristbandCTA({ canScan, outOfTries, pathColor, scanning, onScan, layout }) {
  const C = useColors();
  const [pulse, setPulse] = useState(false);
  const { scale = 1, offsetX = 0, vpWidth = 390 } = layout || {};
  const extraLeft = offsetX / scale;
  const edgeStyle = {
    marginLeft: -extraLeft,
    width: vpWidth / scale,
    paddingLeft: extraLeft + 18,
    paddingRight: extraLeft + 18,
  };

  useEffect(() => {
    if (!canScan) { setPulse(false); return; }
    const t = setInterval(() => setPulse(p => !p), 900);
    return () => clearInterval(t);
  }, [canScan]);

  if (!canScan) {
    return (
      <div style={{
        paddingTop: 13, paddingBottom: 13,
        background: C.navyMid,
        borderTop: `1px solid ${C.dim}`,
        textAlign: "center",
        flexShrink: 0,
        ...edgeStyle,
      }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
          <span style={{ fontSize: 15 }}>🔒</span>
          <span style={{ fontWeight: 600, color: C.muted, fontSize: 12 }}>
            Complete the challenge to unlock
          </span>
        </div>
      </div>
    );
  }

  const accentColor = outOfTries ? C.red : pathColor;

  return (
    <div
      onClick={onScan}
      style={{
        paddingTop: 14, paddingBottom: 14,
        background: accentColor,
        borderTop: `2px solid ${accentColor}`,
        textAlign: "center",
        cursor: "pointer",
        position: "relative",
        overflow: "hidden",
        flexShrink: 0,
        ...edgeStyle,
      }}
    >
      {/* Pulse ring */}
      <div style={{
        position: "absolute", inset: 0,
        border: "2px solid rgba(255,255,255,0.35)",
        transform: `scale(${pulse ? 1.07 : 1})`,
        opacity: pulse ? 0 : 0.55,
        transition: "all 0.9s ease",
        pointerEvents: "none",
      }} />

      {scanning ? (
        <div style={{ color: "#fff", fontWeight: 700, fontSize: 13 }}>🔊 ✓ Progress saved!</div>
      ) : (
        <>
          <div style={{
            display: "flex", alignItems: "center", justifyContent: "center",
            gap: 8, marginBottom: 3,
          }}>
            <WristbandIcon size={18} color="#fff" />
            <span style={{ fontWeight: 800, color: "#fff", fontSize: 13, letterSpacing: 0.3 }}>
              READY — SCAN WRISTBAND TO SAVE
            </span>
          </div>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.75)" }}>
            Tap here to save and continue
          </div>
        </>
      )}
    </div>
  );
}
